// @ts-nocheck
import {
	OAuthProvider,
	LinkedInLoginMessage,
	OAUTH_ACCESS_CODE_REQUEST_MESSAGE,
	QuickbooksOAuthMessage,
	HubSpotOAuthMessage, QuickbooksAuthCodeStatus,
} from './types';
import React, {FunctionComponent, useCallback, useEffect, useState} from 'react';
import {useLocation, useParams, useSearchParams} from 'react-router-dom';
import useCurrentUser from "../../features/authentication/hooks/useUser";
import {
	useCreateOAuthSourceMutation
} from "../../features/api";
import {
	initQueryStateTracker,
	mergeQueryStates,
	QueryStateTracker
} from "../../features/api/helpers";
import {skipToken} from "@reduxjs/toolkit/query";

const isUserCancellation = (msg: string | null) =>
	msg === 'user_cancelled_login' || msg === 'user_cancelled_authorize';

const paramsToParsedParams = (
	rawParams: URLSearchParams,
	apix: OAuthProvider
): LinkedInLoginMessage | QuickbooksOAuthMessage | HubSpotOAuthMessage => {
	const base = {
		provider: apix,
		source: OAUTH_ACCESS_CODE_REQUEST_MESSAGE as typeof OAUTH_ACCESS_CODE_REQUEST_MESSAGE,
	};

	const expectedFields = [
		'error', 'error_description', 'code', 'state', 'realmId'
	];

	const parsed = expectedFields.reduce(
		(acc, next) => ({ ...acc, [next]: rawParams.get(next) }),
		{} as any
	);

	//  if for some reason required info is not in search params at all,
	// return null so message-passing logic knows not to execute
	// if (parsed.error === undefined && parsed.code === undefined) {
	// 	return {};
	// }

	if (parsed.error) {
		const msg = isUserCancellation(parsed.error)
			? parsed.error
			: typeof parsed.error_description === 'string'
			? parsed.error_description
			: 'Login failed with unknown error.';

		return {
			...base,
			state: parsed.state,
			payload: {
				error: msg,
				status: 'error',
				code: null,
				realmId: null,
				state: null
			},
		};
	}

	if (parsed.code) {
		return {
			...base,
			state: parsed.state,
			payload: {
				error: null,
				status: 'success',
				code: parsed.code,
				realmId: parsed.realmId,
				state: parsed.state
			},
		};
	}

	return {
		...base,
		state: parsed.state,
		payload: {
			error: 'No error was offered, but no auth code was available in provider response',
			status: 'error',
			code: null,
			realmId: null,
			state: null
		},
	};
};

export const Callback: FunctionComponent = () => {
	const { oauthProvider } = useParams<{ oauthProvider: OAuthProvider }>();
	const searchParams = useSearchParams()[0];

	const parsedParams = paramsToParsedParams(
		searchParams,
		// probably ok to cast here since this component only gets mounted in callback routes
		oauthProvider as OAuthProvider
	);

	const postMessage = (data: LinkedInLoginMessage | QuickbooksOAuthMessage | HubSpotOAuthMessage) => {
		window.opener.postMessage(data, window.location.origin);
	};

	useEffect(() => {
		if (parsedParams) {
			if (isUserCancellation(parsedParams.payload.error)) {
				// NB: the hook that opened popup window will detect this close and clean itself up
				// if this conditional runs.
				window.close();
				return;
			}

			postMessage(parsedParams);
		}
	}, [parsedParams]);

	return <div>Your request should continue in a moment...</div>;
};


// @ts-ignore
export const OAuthCallback: FunctionComponent = () => {

	const {apix} = useParams<{ apix: OAuthProvider }>();
	const searchParams = useSearchParams()[0];
	// const {code, state, realmId} = useSearchParams();

	const code = searchParams.get('code');
	const state = searchParams.get('state');
	const realmId = searchParams.get('realmId');
	const provider = apix;

	const parsedParams = paramsToParsedParams(
		searchParams, apix as OAuthProvider
	);

	const [connectApi, connectStatus] = useCreateOAuthSourceMutation();

	const postMessage = (data: QuickbooksOAuthMessage | HubSpotOAuthMessage) => {
		// window.opener?.postMessage(data, "*");
		window.opener.postMessage(data, window.location.origin);
	};

	useEffect(() => {
		if (parsedParams) {
			if (isUserCancellation(parsedParams.payload.error)) {
				// NB: the hook that opened popup window will detect this close and clean itself up
				// if this conditional runs.
				window.close();
				return;
			}
			postMessage(parsedParams);
		}
	}, [parsedParams]);

	// useEffect(() => {
	// 	connectApi({ provider, body: {code, state, realmId, provider} });
	// }, []);

	// window.close()
	// window.close();
	// return null
	return <div>Your request should continue in a moment...</div>;
};
	// if (user) {
	// 	return <AppModal
	// 			label={"Share resource"}
	// 			isOpen={true}
	// 			isDirty={formState.isDirty}
	// 			onClose={closeModal}
	// 			onSubmit={handleSubmit(onSubmit)}
	// 			canEdit={canEdit}>
	// 					<Heading style={{padding: 0, margin: 0}} component="h3">
	// 				Comment
	// 			</Heading>
	// 		<SubtleTextbox
	// 				{...register('comment')}
	// 				defaultValue={'Describe your comment'}
	// 				label="Comment"  // "post comment
	// 				isDirty={Boolean(formState.dirtyFields.comment)}
	// 				onReset={() => resetField('comment')}
	// 				error={harvestErrors(
	// 					'comment',
	// 					formState,
	// 					mutationResults
	// 				)}
	// 			/>
	// 			<Heading style={{padding: 0, margin: 0}} component="h3">
	// 				Description
	// 			</Heading>
	// 			<SubtleTextArea
	// 				{...register('description')}
	// 				label="Post"
	// 				style={{minHeight: '300px'}}
	// 				defaultValue={'Describe your share'}
	// 				isDirty={Boolean(formState.dirtyFields.description)}
	// 				onReset={() => resetField('description')}
	// 				error={harvestErrors(
	// 					'description',
	// 					formState,
	// 					mutationResults
	// 				)}
	// 			/>
	// 			{/*<FlexContainer justifyContent="center">*/}
	// 			{/*	<Button*/}
	// 			{/*		disabled={*/}
	// 			{/*			mergedQueryStates.isLoading ||*/}
	// 			{/*			mergedQueryStates.isError ||*/}
	// 			{/*			mergedQueryStates.isSuccess*/}
	// 			{/*		}*/}
	// 			{/*	>*/}
	// 			{/*		<Typography variant='button'>*/}
	// 			{/*			Submit*/}
	// 			{/*		</Typography>*/}
	// 			{/*	</Button>*/}
	// 			{/*</FlexContainer>*/}
	// 			<FormResults
	// 				{...mergedQueryStates}
	// 				onSuccess={closeModal}
	// 				onSuccessDelay={1500}
	// 			/>
	// 	</AppModal>
	// } else {
	// 	return null
	// }
